<template>
  <SessionDetailComponent />
</template>
<script>
import SessionDetailComponent from "@/components/session/SessionDetailComponent.vue";
export default {
  components: {
    SessionDetailComponent,
  },
  name: "PersonalizeSesssion",
};
</script>
<style src="./product.scss" lang="scss" scoped />
